import * as React from "react";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import { Grid, Typography } from "components/controls/widget";
import { Faq } from "common/api/Faqs";
import ReactMarkdown from "react-markdown";

interface FaqsItemProps {
    faq: Faq;
}

type PropsType = FaqsItemProps & WithStyles<typeof styles>;


class FaqsItem extends React.PureComponent<PropsType> {
    render() {
        const { faq, classes } = this.props;
        return <Grid container direction="column" spacing={16} className={classes.root}>
            <Grid item>
                <Grid container direction="column" spacing={8}>
                    <Grid item>
                        <Typography variant="h6">{faq.question}</Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item >
                <Typography component="div">
                    <ReactMarkdown children={faq.answer || ''} />
                </Typography>
            </Grid>
            {
                faq.contact ? <Grid item >
                    <Typography variant="caption">{'Kontakt: ' + faq.contact}</Typography>
                </Grid> : null
            }
        </Grid >
    }
}


const styles = (theme: Theme) => createStyles({
    root: {
        marginBottom: 2 * theme.spacing.unit,
    }

});

export default withStyles(styles)(FaqsItem); 